import { Injectable } from "@angular/core";
import { FirebaseQuery } from "../firebase.query";
import { Observable } from "rxjs";
import { PricelistsService } from "./pricelists.service";
import { PricelistsState, PricelistsStore } from "./pricelists.store";
import { Pricelist } from "app/model/pricelist";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: "root" })
export class PricelistsQuery extends FirebaseQuery<PricelistsState> {
    constructor(protected store: PricelistsStore, protected service: PricelistsService) {
        super(store, service);
    }

    public pricelists$: Observable<Pricelist[]> = this.selectAll({
        filterBy: p => !p.test || !environment.production,
        sortBy: "uploadedAt"
    });

    public pricelistsForCategory$(categoryPath: string): Observable<Pricelist[]> {
        return this.selectAll({
            filterBy: p => (!p.test || !environment.production) && p.parentPath === categoryPath,
            sortBy: "uploadedAt"
        });
    }
}
